// Generated by https?://quicktype.io

export interface User {
    id?: string;
    roles_linked?: RolesLinked[];
    role?: string;
    sub_roles_reference?: RolesLinked[];
    contact_linked?: string;
    accounts_linked?: AccountLinked[];
    trading_accounts_linked?: UserTradingAccountLinked[];
    email?: string;
    salt?: string;
    secret?: string;
    enabled?: boolean;
    verified?: boolean;
    leverage_restriction?: boolean;
    locale_lookup?: string;
    token?: UserToken;
    access?: Access;
    tenant?: string;
    created_date?: string;
}

export interface AccountLinked {
    id?: string;
    name?: string;
    enabled?: boolean;
}

export interface Access {
    login_time?: string;
    login_ip?: string;
}

export interface RolesLinked {
    id?: string;
    type?: string;
}

export interface UserTradingAccountLinked {
    id?: string;
    account?: string;
    trading_account_type?: string;
    is_demo?: boolean;
}

export interface UserToken {
    recovery_token?: string;
    recovery_token_sent_date?: string;
    verification_token?: string;
    verification_token_expiry_date?: string;
}

export interface Watchdog {
    user_id?: string;
    fingerprint?: string;
    ip?: string;
    application_id?: string;
    record_id?: string;
    action_name?: string;
    timestamp?: string;
    table_lookup_name?: string;
}

export interface Watchlist {
    id?: string;
    enabled?: boolean;
    watchlist?: string;
    reason?: string;
    ip_list?: string;
    type?: string;
    notification?: string;
    action?: string;
    action_block?: string;
    action_block_message?: string;
}

export const WatchdogTypes = [
    'ip',
    'block_ip',
    'fingerprint',
    'block_fingerprint'
];
